module.exports = __webpack_public_path__ + "static/media/480.2fee4c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-grass/light/480.png
// module id = 2124
// module chunks = 2